// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-fX8n","content":"styles_content__3WFVH"};